import { importMenu } from "./import-menu";
import { deliverySettings } from "./settings";
import { deliveryReport } from "./report";
import { deliveryMenus } from "./menus";
import { syncMenu } from "./sync-menu";

export const delivery = {
	goBack: "Retour",
	updateManyExternalIntegrations: {
		success: "Integrations mises jour avec succs",
	},
	externalStoreIntegrationStatus: {
		synced: "Synchronisé",
		pendingSyncing: "Synchronisation en attente",
		pendingImporting: "Importation en attente",
	},
	ordersManager: {
		title: "Gestionnaire de commandes",
		description:
			"Suivez et gérez les commandes qui arrivent d'Entregue já, Comanda Online et Pedido na mesa.",
		filter: {
			placeholder: "Filtrer par",
		},
		tabs: {
			newOrders: "Nouvelles commandes",
			inDelivery: "En livraison",
			completed: "Terminées",
		},
		createOrder: "Créer une commande",
		selectMenuModal: {
			title: "Choisissez le menu pour passer la commande",
			searchPlaceholder: "Rechercher par menu",
			productsCount: "{{value}} produits",
			cancel: "Annuler",
			select: "Sélectionner le menu",
			empty: "Aucun menu trouvé.",
		},
		createOrderScreen: {
			back: "Retour",
			searchPlaceholder: "Rechercher par nom ou article de la commande",
			filterBy: "Filtrer par",
			allCategories: "Toutes les catégories",
			all: "Toutes",
			add: "Ajouter",
			added: "Ajouté",
			cartTitle: "Articles ajoutés",
			emptyTitle: "Rien ici pour le moment",
			emptyDescription: "Les articles apparaîtront ici au fur et à mesure",
			subtotal: "Sous-total",
			discount: "Remise",
			total: "Total",
			clear: "Vider les articles",
			finalize: "Finaliser la commande",
			emptyProducts: "Aucun produit trouvé.",
			productDetail: {
				title: "Détails du produit",
				observationLabel: "Observations",
				observationPlaceholder: "Saisissez ici une observation pour la commande",
				addProduct: "Ajouter le produit",
				complementsRule: "Choisissez jusqu'à {{value}} options",
				complementsRuleRequired: "Choisissez de {{min}} à {{max}} options",
			},
			clearModal: {
				title: "Vider les articles",
				description:
					"Êtes-vous sûr de vouloir vider les articles ? Une fois confirmé, vous devrez les ajouter à nouveau pour finaliser.",
				cancel: "Annuler",
				confirm: "Vider les articles",
			},
		},
		checkout: {
			back: "Retour",
			title: "Paiement de la commande",
			customerInfo: {
				title: "Informations du client",
				name: "Nom",
				namePlaceholder: "Saisissez le nom et le prénom du client",
				phone: "Téléphone",
				phonePlaceholder: "Saisissez le numéro de téléphone du client",
				cpf: "CPF",
				cpfPlaceholder: "Saisissez le numéro de CPF du client",
				sameWhatsapp: "Même numéro pour WhatsApp",
			},
			delivery: {
				title: "Mode de livraison",
				pickup: "Retrait en magasin",
				deliver: "Livrer via mobotoy",
				addressTitle: "Informations d'adresse",
				cep: "Code postal",
				cepPlaceholder: "Saisissez le code postal du client",
				street: "Rue",
				streetPlaceholder: "Saisissez l'adresse du client",
				number: "Numéro",
				numberPlaceholder: "Saisissez le numéro",
				complement: "Complément",
				complementPlaceholder: "Saisissez le complément",
			},
			payment: {
				title: "Modes de paiement",
				pix: "Paiement via Pix",
			},
			summary: {
				title: "Résumé de la commande",
				deliveryFee: "Frais de livraison",
				total: "Total",
				finalize: "Finaliser la commande",
			},
		},
		loading: "Chargement",
		total: "Total: {{value}}",
		new: "Nouveau",
		emptyState: {
			title: "Aucune commande {{status}}.",
			description:
				"Nous vous enverrons une notification lorsque vous recevrez une nouvelle commande.",
		},
		immersion: {
			enter: "Immersion",
			exit: "Quitter l'immersion",
		},
		sound: {
			on: "Son activé",
			off: "Son coupé",
		},
		whatsNew: {
			intro: {
				title: "Du nouveau par ici ! 🎉",
				description:
					"Nous avons mis à jour le gestionnaire de commandes. Envie de voir vite ce qui a changé ?",
				start: "Voir les nouveautés",
			},
			step: "Étape {{current}} sur {{total}}",
			next: "Suivant",
			finish: "Compris",
			skip: "Passer",
			test: "Jouer un son d'exemple",
			immersion: {
				title: "Nouveau : Mode immersion",
				description:
					"Affichez le gestionnaire en plein écran, sans menus, idéal au comptoir.",
			},
			sound: {
				title: "Nouveau : Son de nouvelle commande",
				description:
					"Nous jouons une alerte sonore à l'arrivée d'une nouvelle commande. Utilisez le bouton pour l'activer ou la couper.",
			},
		},
	},
	deliverySettings,
	deliveryReport,
	deliveryMenus,
	syncMenu,
	importMenu,
};
